var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-viewer-container"},[(!_vm.isMobile)?_c('iframe',{staticClass:"pdf-iframe",attrs:{"src":_vm.pdfUrl,"frameborder":"0","allowfullscreen":"","type":"application/pdf"}}):_c('div',{staticClass:"mobile-fallback"},[_c('p',{staticClass:"fallback-message"},[_vm._v("正在为您打开 PDF 文件...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }